/**
 * Exports all the common configuration for client app and server to run the client app
 */
import defaultConfig from './default';
export default defaultConfig;
